import { Route, Routes } from "react-router-dom";

import TeacherForm from "../Teacher/TeacherForm";
import TeacherList from "../Teacher/TeacherList";
import Login from "../Login";
import StudentForm from "../Student/StudentForm";
import StudentList from "../Student/StudentList";
import ProfileForm from "../Profile/ProfileForm";
import ProfileSelect from "../Profile/ProfileList";
import Manager from "../ManagerDashboard";
import ModuleClass from "../Modules/ModuleClass";
import Modules from "../Modules/ModulesList";
import ModuleDetails from "../Modules/ModuleDetails";
import VideoForm from "../VideoForm";
import FormClass from "../Classes/FormClass";
import ClassList from "../Classes/ClassList";
import ClassDetails from "../Classes/ClassDetails";
import ProfileFormEdit from "../Profile/ProfileFormEdit";
import AtvForm from "../AtvForm";
import SinalarioList from "../Sinalario/SinalarioList";
import AddVerbete from "../Sinalario/AddVerbete";
import VerbeteDetails from "../Sinalario/SinalarioDetails";
import EditVerbete from "../Sinalario/VerbeteEditForm";
import ErrorPage from "../ErrorPage";
import LetterSelection from "../Sinalario/LetterSelection";
import Lessons from "../Lessons";
import News from "../News";
import Notifications from "../Notifications";
import Suggestions from "../Suggestions";
import SuggestionDetail from "../Suggestions/SuggestionDetail";
import Faq from "../FAQ";
import Register from "../Register";
import CompleteRegistration from "../Register/CompleteRegistration";
import UserProfile from "../Register/UserProfile";
import EditAccount from "../Register/EditAccount";
import SettingsPage from "../Settings";
import PersonalizationPage from "../Settings/Personalization";
import ChangePasswordPage from "../Settings/ChangePassword";
import PrivacyPage from "../Settings/Privacy";
import UserManagement from "../UserManagement";
import Dactylology from "../Sinalario/Dactylology";
import AIAssistant from "../AIAssistant";
import TutorIA from "../AIAssistant/TutorIA";
import Translator from "../AIAssistant/Translator";
import Ranking from "../Ranking";
import PublicProfile from "../Ranking/PublicProfile";
import LessonContent from "../Lessons/LessonContent";
import PersonalRepository from "../PersonalRepository";
import Dashboard from "../Dashboard";
import Support from "../Support";
import Community from "../Community";
import FavoritesPage from "../Favorites";
import SearchPage from "../Search";
import AboutPage from "../About";
import SuggestionSubmitPage from "../SuggestionSubmit";
import MyNotificationsPage from "../MyNotifications";
import GamesPage from "../Games";
import GamePlayPage from "../Games/GamePlay";
import MapPage from "../Map";
import MapPoiDetailsPage from "../Map/MapPoiDetails";
import CategorySelection from "../Sinalario/CategorySelection";
import UserFAQ from "../UserFAQ";
import UserNews from "../UserNews";
import SuggestionsHub from "../SuggestionsHub";
import MySuggestions from "../MySuggestions";

function Router() {
  return (
    <Routes>
      <Route path="/" element={<Login />} />
      <Route path="/ " element={<ErrorPage status="404" />} />
      <Route path="/403" element={<ErrorPage status="403" />} />
      <Route path="/404" element={<ErrorPage status="404" />} />
      <Route path="/500" element={<ErrorPage status="500" />} />
      <Route path="/505" element={<ErrorPage status="500" />} />
      <Route path="/teachers" element={<TeacherList />} />
      <Route path="/give-classes" element={<TeacherForm />} />
      <Route path="/new-student" element={<StudentForm />} />
      <Route path="/students" element={<StudentList />} />
      <Route path="/login" element={<Login />} />
      <Route path="/register" element={<Register />} />
      <Route path="/complete-registration" element={<CompleteRegistration />} />
      <Route path="/profile" element={<UserProfile />} />
      <Route path="/edit-account" element={<EditAccount />} />
      <Route path="/settings" element={<SettingsPage />} />
      <Route
        path="/settings/personalization"
        element={<PersonalizationPage />}
      />
      <Route path="/change-password" element={<ChangePasswordPage />} />
      <Route path="/privacy" element={<PrivacyPage />} />
      <Route path="/manager" element={<Manager />} />
      <Route path="/manager/users" element={<UserManagement />} />
      <Route path="/add-profile" element={<ProfileForm />} />
      <Route path="/profiles" element={<ProfileSelect />} />
      <Route path="/new-module" element={<ModuleClass />} />
      <Route path="/modules" element={<Modules />} />
      <Route path="/modulesDetails/" element={<ModuleDetails />} />
      <Route path="/new-video/" element={<VideoForm />} />
      <Route path="/new-class/" element={<FormClass />} />
      <Route path="/classes/" element={<ClassList />} />
      <Route path="/classDetails/" element={<ClassDetails />} />
      <Route path="/edit-profile/" element={<ProfileFormEdit />} />
      <Route path="/AtvForm/" element={<AtvForm />} />
      <Route path="/sinalario" element={<LetterSelection />} />
      <Route path="/sinalario/categories" element={<CategorySelection />} />
      <Route path="/sinalario/list" element={<SinalarioList />} />
      <Route path="/Add-Verbete" element={<AddVerbete />} />
      <Route path="/VerbeteDetails" element={<VerbeteDetails />} />
      <Route path="/Edit-Verbete" element={<EditVerbete />} />
      <Route path="/dactylology" element={<Dactylology />} />
      <Route path="/lessons" element={<Lessons />} />
      <Route path="/lessons/:id" element={<LessonContent />} />
      <Route path="/news" element={<News />} />
      <Route path="/notifications" element={<Notifications />} />
      <Route path="/suggestions" element={<Suggestions />} />
      <Route path="/suggestions/:uid" element={<SuggestionDetail />} />
      <Route path="/faq" element={<Faq />} />
      <Route path="/ajuda" element={<UserFAQ />} />
      <Route path="/faq-usuario" element={<UserFAQ />} />
      <Route path="/avisos" element={<UserNews />} />
      <Route path="/sugestoes" element={<SuggestionsHub />} />
      <Route path="/sugestoes/minhas" element={<MySuggestions />} />
      <Route path="/ai-assistant" element={<AIAssistant />} />
      <Route path="/ai-assistant/tutor" element={<TutorIA />} />
      <Route path="/ai-assistant/translator" element={<Translator />} />
      <Route path="/ranking" element={<Ranking />} />
      <Route path="/ranking/user/:userId" element={<PublicProfile />} />
      <Route path="/repository" element={<PersonalRepository />} />
      <Route path="/games" element={<GamesPage />} />
      <Route path="/games/:gameId" element={<GamePlayPage />} />
      <Route path="/dashboard" element={<Dashboard />} />
      <Route path="/apoiar" element={<Support />} />
      <Route path="/comunidade" element={<Community />} />
      <Route path="/favorites" element={<FavoritesPage />} />
      <Route path="/search" element={<SearchPage />} />
      <Route path="/map" element={<MapPage />} />
      <Route path="/map/poi/:poiId" element={<MapPoiDetailsPage />} />
      <Route path="/about" element={<AboutPage />} />
      <Route path="/enviar-sugestao" element={<SuggestionSubmitPage />} />
      <Route path="/notificacoes" element={<MyNotificationsPage />} />
      <Route path="*" element={<ErrorPage status="404" />} />
    </Routes>
  );
}
export default Router;
